import UtagHelper from 'utilities/utagHelper';
import { recordPage, RELIABLE } from 'utilities/uTagging';
import { PATH_EXIT } from 'constants/uTagConstants/paths';
import cryptoJS from 'crypto-js';

export const doTagLogoutView = ({ userProfile, products }) => {
    const { recordId, userId, product, promoCode, identityMethod, investmentType, docNumber } = userProfile;

    recordPage(
        PATH_EXIT,
        recordId,
        userId,
        product,
        products.get('productsDescription'),
        promoCode ?? '',
        UtagHelper.getJointHolderInfoFromUserProfile(userProfile),
        RELIABLE[identityMethod],
        '',
        investmentType,
        {
            identificadorOnboarding: docNumber ? cryptoJS.SHA256(docNumber).toString() : '',
        }
    );

    return PATH_EXIT;
};
